//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

//成本确认单
const costConfirmationList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/productionCenter/costConfirmation/list.vue')),
    'costConfirmation'
  );
//新增成本确认单
const costConfirmationAdd = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/costConfirmation/add.vue');
//双击进入成本确认单详情
const costConfirmationDetails = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/costConfirmation/details.vue');
const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'costConfirmationList',
      name: 'costConfirmationList',
      component: costConfirmationList,
      meta: {
        keepAlive: true,
        title: '成本确认单',
      },
    },
    {
      path: 'costConfirmationAdd',
      name: 'costConfirmationAdd',
      component: costConfirmationAdd,
      meta: {
        keepAlive: true,
        title: '新增成本确认单',
      },
    },
    {
      path: 'costConfirmationDetails',
      name: 'costConfirmationDetails',
      component: costConfirmationDetails,
      meta: {
        keepAlive: true,
        title: '成本确认单详情',
      },
    },
  ],
};
export default productionRouter;
